{
  "imagesUploadLimit": 10,
  "maxImageSize": 10485760,
  "minWidth": 200,
  "minHeight": 200,
  "maxWidth": 8192,
  "maxHeight": 8192
}
